<style lang='scss' scoped>
.navlist {
    max-width: 60%;
    & > a {
        color: #fff;
        cursor: pointer;
    }
}
// 小屏幕优化
@media screen and (max-width: 1560px) {
    .navlist {
        max-width: 45%;
    }
}
@media screen and (max-width: 1440px) {
    .navlist {
        max-width: 40%;
    }
}
@media screen and (max-width: 1366px) {
    .navlist {
        max-width: 36%;
    }
}
@media screen and (max-width: 1280px) {
    .navlist {
        max-width: 34%;
    }
}
.nav-title {
    user-select: none;
    float: left;
    padding: 0 3px;
    margin-right: 2px;
    box-sizing: border-box;
    border: 1px dashed transparent;
    cursor: pointer;
    overflow: hidden;
    word-break: keep-all;
    white-space: nowrap;
    text-overflow: ellipsis;
    min-width: 36px;
    max-width: 100px;
    &:hover {
        color: #4093ff;
    }
    &.nav-title-active {
        color: #4093ff;
        background-color: #09659A;
        border-color: #4093ff;
    }
}
</style>


<template>
	<aside class="navlist">
        <!-- <a class="font-14" @click="showCollect">我的收藏</a> -->
		<a @click="openModal('modvisible')" class="font-14 margin-left-15" id="nav-module-title">
			{{$t('global.nav.module')}}
			<vIcon type="arrow-dropdown" size="13"></vIcon>
		</a>

		<transition appear name="move-up">
			<compNavList v-if="visible" />
			<compShortCut v-if="modvisible" />
		</transition>
	</aside>
</template>

<script>
import compNavList from './list'
import compShortCut from './shortcut'
import { mapState, mapGetters, mapMutations } from 'vuex';
import { HttpNavMenu } from '../../../../service/base';
export default {
	components: {
		compNavList,
		compShortCut
	},
	data() {
		return {
			visible: false,
			modvisible: false,
		};
	},
	created() {
		this.getNavMenu();
	},
    mounted(){
        this.bus.$on("changetreasure", value => {
        // console.log(value)
        setTimeout(() => {
            this.openModal('visible')
        }, 300)

    });
    },
	computed: {
		...mapState('layout', ['routeId']),
		...mapGetters('layout', ['getNavTitle', 'getMenuList']),
	},
	methods: {
		...mapMutations('layout', ['setRouteId', 'setNavTitleIds']),
		openModal(type) {
			const value = this[type];
			this.modvisible = this.visible = false;
			this[type] = !value;
		},
		/**
         * 获取默认路由数据
         * @param {*} state
         * @param {*} getters
         */
		getRouteData(data) {
			const { linklistId = [], moduleId } = data,
				menuList = this.getMenuList;
			if (linklistId) {
				const getChildRouteId = function (linklistId, moduleId) {
					return linklistId.reduce((pre, cur, index, arr) => {
						if (pre) return pre;
						const routeData = menuList[cur];
						const _moduleId = routeData.moduleId;
						const hasModuleId = !_moduleId || _moduleId == moduleId;
						if (!hasModuleId) return;
						if (routeData.linklistId) {
							return getChildRouteId(routeData.linklistId, moduleId);
						}
						return cur;
					}, null)
				}
				const routeId = getChildRouteId(linklistId, moduleId)
				if (routeId) data = menuList[routeId];
			}
			return data;
		},
		handleRoute(data) {
			const { isVue, id } = this.getRouteData(data);
			if (isVue) {
				this.$nextTick(()=>{
					this.setRouteId(id);
				})
			}
		},
		getLink(data) {
			const { isVue, props = {} } = this.getRouteData(data);
			return isVue ? props.to : props.href;
		},
		handleClasses(item) {
			const { props = {}, id } = this.getRouteData(item);
			const hasMoreNavTitle = item.id !== id && this.getNavTitle.some(item => item.id === id);
			const href = props.to || props.href;
			return !hasMoreNavTitle && href && this.$route.path.indexOf(href) > -1 ? 'nav-title nav-title-active' : 'nav-title'
		},
		getNavMenu() {
			HttpNavMenu().then(res => {
				const data = res.data || [];
				this.setNavTitleIds(data);

                this.bus.$emit("changemenu", data);
			})
		},
        // showCollect(){
        //     this.bus.$emit("changecollect", 'showcoll');
        // }
	}
};
</script>
